import { render } from "./ModalRatesInvoices.vue?vue&type=template&id=579c7c58"
import script from "./ModalRatesInvoices.vue?vue&type=script&lang=js"
export * from "./ModalRatesInvoices.vue?vue&type=script&lang=js"

import "./ModalRatesInvoices.vue?vue&type=style&index=0&id=579c7c58&lang=scss"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__